import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import noop from 'lodash/noop';
import { setPassportWidgetsJsReady } from '../passPortWidgetsSlice';
import appendPassportWidgetsScript from './appendPassportWidgetsScript';

const usePassportWidgets = () => {
  const dispatch = useDispatch();

  const initPassportWidgets = useCallback(({
    passportInfo: { passportSDKUrl } = {}, initPassportCallback = noop,
  }) => {
    appendPassportWidgetsScript(passportSDKUrl).then((ready) => {
      if (ready) {
        dispatch(setPassportWidgetsJsReady(true));
      }
      initPassportCallback();
    });
  }, [ dispatch ]);

  return { initPassportWidgets };
};

export default usePassportWidgets;
